// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'triangle-mixed-left';

export const Component = () => (
  <path d='m12.26 1 12.261 22.558H0L12.26 1Zm0 21.6h10.632L12.26 3.06V22.6Z' />
);

export const viewBox = '0 0 25 25';
